export const baths = (listing) => {
  return `${listing.fullBaths || ''}${listing.partialBaths ? '/' + listing.partialBaths : ''}`;
};


// WEBPACK FOOTER //
// ./src/components/shared/listing.js